import { createReducer } from 'redux-act';
import CONSTANTS from 'utils/constants';
import {
  PREFERENCES_SET_LOCALE,
  PREFERENCES_SET_MAP_OPTIONS,
  PREFERENCES_SET_MAP_STYLE,
  PREFERENCES_CLEAR_DATA_LOGOUT,
  PREFERENCES_SHOW_FOOTER,
  PREFERENCES_HIDE_FOOTER,
} from 'state/actions/preferences';

const initialState = {
  locale: null,
  displayFooter: true,
  mapOptions: { center: null, zoom: null },
  mapStyle: CONSTANTS.MAPBOX.STYLES.STREETS,
};

export const preferencesReducer = createReducer(
  {
    [PREFERENCES_SET_LOCALE]: (state, payload) => ({
      ...state,
      locale: payload.locale,
    }),
    [PREFERENCES_SET_MAP_OPTIONS]: (state, payload) => ({
      ...state,
      mapOptions: payload,
    }),
    [PREFERENCES_SET_MAP_STYLE]: (state, payload) => ({
      ...state,
      mapStyle: payload,
    }),
    [PREFERENCES_CLEAR_DATA_LOGOUT]: (state) => ({
      ...state,
      displayFooter: initialState.displayFooter,
      mapOptions: initialState.mapOptions,
      mapStyle: initialState.mapStyle,
    }),
    [PREFERENCES_SHOW_FOOTER]: (state) => ({
      ...state,
      displayFooter: true,
    }),
    [PREFERENCES_HIDE_FOOTER]: (state) => ({
      ...state,
      displayFooter: false,
    }),
  },
  initialState
);
